export default __webpack_public_path__ + "static/media/mat.affd0686.png";